import { CampaignLabel } from 'modules/domains/campaign';
import { SettingsTab } from './SettingsTakeover.constants';

/**
 * Get the metrics tab based on whether journey goals are enabled
 * @param isJourneyGoalsEnabled is feature flag `JourneyGoals` enabled
 * @returns SettingsTab.ConversionsAndMetrics | SettingsTab.Metrics
 */
export const getMetricsTab = (isJourneyGoalsEnabled = false) =>
  isJourneyGoalsEnabled ? SettingsTab.ConversionsAndMetrics : SettingsTab.Metrics;

// remove the feature flag once we have the feature enabled for everyone
export const getSettingsTabs = (isJourneyGoalsEnabled = false, isJourneyGoalsWithExits = false) => {
  const tabs = [SettingsTab.About, getMetricsTab(isJourneyGoalsEnabled)];
  if (isJourneyGoalsWithExits) {
    tabs.push(SettingsTab.ExitRules);
  }
  return tabs;
};

export const getJourneyLabels = (labels: string[], projectLabels: CampaignLabel[]) =>
  projectLabels
    ?.filter((label: CampaignLabel) => labels?.includes(label?.name))
    ?.map((label: CampaignLabel) => Number(label.id)) || [];
